import { useLocation, useNavigate } from "react-router-dom";
import NavButton from "./NavButton";
import { LogoutButton } from "./LogoutButton";
import { NAV_ITEMS } from "../../constants/NavItems";

export default function MobileMenu({ isAdmin, menuOpen, closeMenu }) {
  const location = useLocation();
  const navigate = useNavigate();
  const computedTabIndex = menuOpen ? 0 : -1;

  return (
    <div
      id="mobile-menu"
      role="menu"
      className={
        menuOpen
          ? "transform transition-all duration-300 p-5 translate-x-0 opacity-100 visible pointer-events-auto"
          : "transform transition-all duration-300 p-5 translate-x-full opacity-0 invisible pointer-events-none absolute w-full"
      }
    >
      {isAdmin && (
        <div className="flex flex-col items-center gap-2 pb-2">
          {NAV_ITEMS.map((item) => (
            <NavButton
              key={item.path}
              label={item.label}
              isActive={location.pathname === item.path}
              onClick={() => {
                navigate(item.path);
                closeMenu();
              }}
              tabIndex={computedTabIndex}
              aria-hidden={!menuOpen}
            />
          ))}
        </div>
      )}
      <LogoutButton />
    </div>
  );
}
